import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("foreignObject", {
        width: "2040",
        height: "2040",
        x: "-1020",
        y: "-1020",
        transform: "rotate(90 0 24)scale(.024)"
      }, [
        _createElementVNode("div", {
          xmlns: "http://www.w3.org/1999/xhtml",
          style: {"background":"conic-gradient(from 90deg,currentColor 0deg,currentColor 63.243deg,rgba(255,255,255,0) 300deg)","height":"100%","width":"100%","opacity":"1"}
        })
      ])
    ], -1),
    _createElementVNode("path", { d: "M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24M7.177 24c0 9.291 7.532 16.823 16.823 16.823S40.823 33.291 40.823 24 33.291 7.177 24 7.177 7.177 14.709 7.177 24" }, null, -1),
    _createElementVNode("circle", {
      cx: "24.24",
      cy: "44.4",
      r: "3.6",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", { d: "M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24M7.177 24c0 9.291 7.532 16.823 16.823 16.823S40.823 33.291 40.823 24 33.291 7.177 24 7.177 7.177 14.709 7.177 24" })
      ])
    ], -1)
  ]))]))
}
export default { render: render }